/**
 * Prints a message to the console if the `enabled` argument is `true`.
 * 
 * @param {boolean} enabled - Whether or not to log the message.
 * @param {string} message - The message to log in the browser console.
 */
export function maybeLog( enabled, message ) {
    if ( enabled ) {
        console.log( message );
    }
}
